import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/content/[...slug]/ContentPage.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/layout/template.tsx")